export default __webpack_public_path__ + "static/media/alert-circle-cancel.615d824d.svg";